import { render } from "./AccordionTile.vue?vue&type=template&id=5ac8f1f2&scoped=true"
import script from "./AccordionTile.vue?vue&type=script&lang=js"
export * from "./AccordionTile.vue?vue&type=script&lang=js"

import "./AccordionTile.vue?vue&type=style&index=0&id=5ac8f1f2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ac8f1f2"]])

export default __exports__